
import type {
  TranslationTypes,
  PageWideTranslation,
  CreatePageWideTranslationOptions,
} from '@layers/web/utils/types/cms.ts'

const translationTypes: TranslationTypes = {
  i18n: 'locale',
  translation: 'translation',
} as const

const createPageWideTranslation = (
  i18n: string[] = [],
  translation: string[] = [],
  data: Record<string, any> = {}
): PageWideTranslation => ({
  locale: i18n,
  translation,
  translationData: data,
})

const mergePageWideTranslations = (
  values: PageWideTranslation[]
): PageWideTranslation => {
  const locale = new Set<string>()
  const translation = new Set<string>()
  let translationData: Record<string, any> | null = null

  for (const value of values) {
    value.locale.forEach(key => locale.add(key))
    value.translation.forEach(key => translation.add(key))
    if (value.translationData) {
      translationData = { ...(translationData ?? {}), ...value.translationData }
    }
  }

  return {
    locale: [...locale],
    translation: [...translation],
    translationData,
  }
}

export {
  translationTypes,
  createPageWideTranslation,
  mergePageWideTranslations,
}

export type {
  TranslationTypes,
  PageWideTranslation,
  CreatePageWideTranslationOptions,
}
